<script setup lang="ts">
import RxIcon from '@assets/icons/rx.svg';
import MenuCard from './MenuCard.vue';
import type { NavItem } from './types';

defineProps<{
  item: NavItem;
}>();

const defaultCards = [
  {
    title: 'Discover treatments',
    image: 'https://uat.jrnys.com/jrnys/images/campaign-page/Stocksy_txpc66d6a4eH2j300_OriginalDelivery_5011594_edit-1.jpg?v=1711977280',
    href: '#',
  },
  {
    title: 'See if you are eligible',
    image: 'https://uat.jrnys.com/jrnys/images/campaign-page/Stocksy_txpc66d6a4eH2j300_OriginalDelivery_5011594_edit-1.jpg?v=1711977280',
    href: '#',
  },
];
</script>

<template>
  <div class="mega-menu bg-white shadow-lg rounded-b-lg">
    <div class="max-w-4xl mx-auto py-32 lg:py-40">
      <div class="flex gap-32 lg:gap-48">
        <!-- Left: Sub-links -->
        <div
          v-if="item.children?.length"
          class="shrink-0 w-1/3"
        >
          <p class="mb-16 text-12 font-semibold uppercase tracking-widest text-teal-500">
            {{ item.childrenLabel ?? item.label }}
          </p>
          <ul class="flex flex-col gap-2">
            <li
              v-for="child in item.children"
              :key="child.href"
            >
              <a
                :href="child.href"
                class="mega-menu__link group flex items-center gap-8 py-8 text-16 text-deep-blue transition-colors"
              >
                <span class="mega-menu__link-text">{{ child.label }}</span>
                <RxIcon
                  v-if="child.icon === 'rx'"
                  class="size-16 shrink-0 text-copper-300"
                />
              </a>
            </li>
          </ul>
        </div>

        <!-- Right: Feature Cards -->
        <div class="flex flex-1 gap-16 lg:gap-20">
          <MenuCard
            v-for="card in (item.cards?.length ? item.cards : defaultCards)"
            :key="card.href"
            :title="card.title"
            :image="card.image"
            :href="card.href"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.mega-menu {
  &__link-text {
    position: relative;
    display: inline-block;

    &::after {
      content: '';
      position: absolute;
      bottom: -2px;
      left: 0;
      width: 100%;
      height: 1px;
      background-color: currentColor;
      transform: scaleX(0);
      transform-origin: left;
      transition: transform 0.2s ease;
    }
  }

  &__link:hover &__link-text::after {
    transform: scaleX(1);
  }
}
</style>
